// router
import router from '@/router';

// utils
import { haveProperty } from '@/utils/';

/**
 *
 * Criação do objecto de um template de e-mail.
 * Esta função irá preparar o objecto a ser enviado para API, onde só os campos
 * preenchidos na página é que serão enviados. Assim irá permitir usar esta função
 * na adição e na edição deste modelo.
 *
 * @param {Object}  data
 *
*/
const create = data => {
    const template = {
        ...( data.id && { id: data.id }),
        campaign_id: router.currentRoute.params.campaingId,
        ...( data.name && { name: data.name }),
        ...( data.subject && { subject: data.subject }),
        ...( data.body && { body: data.body })
    };

    if ( haveProperty( data, 'attachments' ) ) {
        data.attachments.forEach( ( attachment, index ) => {
            template[`attachments[${index}][file]`] = attachment;
            template[`attachments[${index}][alias]`] = attachment.name;
        });
    }

    return template;
};
const requiredFields = [
    { field: 'name', isRequiredOnEdit: false },
    { field: 'subject', isRequiredOnEdit: false },
    { field: 'body', isRequiredOnEdit: false }
];

export {
    create,
    requiredFields
};